var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._l(_vm.tags, function (item) {
        return _c(
          "yxt-tag",
          {
            key: item.id,
            staticClass: "mr8 mb8",
            attrs: { closable: !_vm.disabled, "disable-transitions": false },
            on: {
              close: function ($event) {
                return _vm.close(item)
              },
            },
          },
          [_vm._v("\n    " + _vm._s(item.name) + "\n  ")]
        )
      }),
      _vm.disabled && _vm.tags.length === 0
        ? _c("span", [_vm._v("--")])
        : !_vm.disabled
        ? _c(
            "yxt-button",
            { attrs: { type: "primary" }, on: { click: _vm.select } },
            [_vm._v(_vm._s(_vm.$t("pc_biz_select_ability" /** 选择能力 */)))]
          )
        : _vm._e(),
      _c(
        "yxt-drawer",
        {
          attrs: {
            title: _vm.$t("pc_biz_select_ability" /** 选择能力 */),
            size: "960px",
            "destroy-on-close": "",
            visible: _vm.visible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c("yxtbiz-ability-selector", {
            ref: "selector",
            attrs: { selectedData: _vm.list, limit: 20 },
            on: {
              "update:selectedData": function ($event) {
                _vm.list = $event
              },
              "update:selected-data": function ($event) {
                _vm.list = $event
              },
            },
          }),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "yxt-button",
                { attrs: { plain: "" }, on: { click: _vm.cancel } },
                [_vm._v(_vm._s(_vm.$t("pc_biz_comment_cancel" /** 取消 */)))]
              ),
              _c(
                "yxt-button",
                { attrs: { type: "primary" }, on: { click: _vm.confirm } },
                [_vm._v(_vm._s(_vm.$t("pc_biz_common_btn_sure" /** 确定 */)))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }